module.exports = __webpack_public_path__ + "static/image/merchants-related.svg?310f6771997116e20b0f92ebf411607d";